import { Button, Divider } from "antd";
import React from "react";
import { ParseMessage } from "~/components/atom/parseMessage.jsx";
import { $t, i18n } from "~/i18n.js";
import AddonsSelect from "./AddonsSelect.jsx";

export default function StepAanschaf({
  product,
  checkoutItem,
  setCheckoutItem,
  onNext
}) {
  if (!product) return null;
  const basePrice = parseFloat(product.base_price || 0);
  const symbol = i18n.currencySymbol;
  const addons = checkoutItem.addons || [];

  // Calculate total price for all addons
  const addonsTotal = addons.reduce(
    (sum, addon) => sum + (addon.price || 0),
    0
  );
  const total = basePrice + addonsTotal;

  // Keep checkoutItem.amount and total_price in sync with UI
  React.useEffect(() => {
    if (
      checkoutItem.amount !== basePrice ||
      checkoutItem.total_price !== total
    ) {
      setCheckoutItem({
        ...checkoutItem,
        total_price: total,
      });
    }
    // eslint-disable-next-line
  }, [basePrice, total]);

  return (
    <>
      {product.description && (
        <div>
          <ParseMessage message={product.description} />
          <Divider />
        </div>
      )}
      <p>
        <span className="bold label">{$t("Basisprijs")}</span> {symbol}{" "}
        {basePrice.toFixed(2)} <span>{product.base_label}</span>
      </p>
      <AddonsSelect
        addons={addons}
        setCheckoutItem={setCheckoutItem}
        checkoutItem={checkoutItem}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: 16,
        }}
      >
        <p className="title">{$t("Totaal")}</p>
        <b>
          {symbol} {total.toFixed(2)}
        </b>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 24,
        }}
      >
        <span />
        <Button type="primary" onClick={onNext}>
          {$t("Volgende")}
        </Button>
      </div>
    </>
  );
}
